/* CALYNTH · Talla sin preseleccionar (B1)
   - La ficha entra sin ninguna talla marcada. Mientras tanto, el precio y la tarjeta de stock
     muestran la primera talla disponible (la que Shopify usa por defecto, normalmente la S).
   - Al elegir una talla, la ficha se actualiza y muestra las unidades de esa talla.
   - Si se cambia de color sin haber elegido talla, la talla sigue sin marcar.
   - "Add to cart", la barra fija y el pago exprés piden elegir talla antes de continuar.
   Solo actúa en la ficha principal; quick add, tarjetas y productos sin tallas no cambian. */
(function () {
  if (window.__clySizeRequired) return;
  window.__clySizeRequired = true;

  var root = document.documentElement;
  var chosen = false;
  var MESSAGE = 'Please select a size';

  function picker() {
    return document.querySelector('variant-picker[data-template-product-match="true"]');
  }

  function section() {
    var p = picker();
    return p ? p.closest('.shopify-section') : null;
  }

  function sizeFieldset() {
    var p = picker();
    if (!p) return null;
    var sets = p.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var fs = sets[i];
      if (fs.querySelector('.cly-find-size, .cly-size-trigger')) return fs;
      var legend = fs.querySelector('legend');
      var name = legend ? legend.textContent.trim().split(/\s+/)[0].toLowerCase() : '';
      if (name === 'size' || name === 'talla') return fs;
    }
    return null;
  }

  function guardCheckout(on) {
    var sec = section();
    if (!sec) return;
    sec.querySelectorAll('.accelerated-checkout-block').forEach(function (block) {
      var guard = block.querySelector(':scope > .cly-size-guard');
      if (on && !guard) {
        guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'cly-size-guard';
        guard.setAttribute('aria-label', MESSAGE);
        block.appendChild(guard);
      } else if (!on && guard) {
        guard.remove();
      }
    });
  }

  function ensureNote(fs) {
    var note = fs.querySelector('.cly-size-note');
    if (note) return note;
    note = document.createElement('p');
    note.className = 'cly-size-note';
    note.setAttribute('role', 'alert');
    fs.appendChild(note);
    return note;
  }

  function clearSize() {
    if (chosen) return;
    var fs = sizeFieldset();
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = false;
      input.removeAttribute('checked');
      input.setAttribute('data-current-checked', 'false');
      input.setAttribute('data-previous-checked', 'false');
    });
    ensureNote(fs);
    root.setAttribute('data-cly-size-pending', '');
    guardCheckout(true);
  }

  function release() {
    chosen = true;
    root.removeAttribute('data-cly-size-pending');
    guardCheckout(false);
    var fs = sizeFieldset();
    if (!fs) return;
    fs.classList.remove('cly-size-missing');
    var note = fs.querySelector('.cly-size-note');
    if (note) note.remove();
  }

  function showMissing() {
    var fs = sizeFieldset();
    if (!fs) return;
    var note = ensureNote(fs);
    note.textContent = '';
    fs.classList.remove('cly-size-missing');
    void fs.offsetWidth;
    fs.classList.add('cly-size-missing');
    note.textContent = MESSAGE;
    var rect = fs.getBoundingClientRect();
    if (rect.top < 80 || rect.bottom > window.innerHeight) {
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function isPending() {
    return !chosen && root.hasAttribute('data-cly-size-pending');
  }

  window.addEventListener('click', function (event) {
    if (!isPending() || !(event.target instanceof Element)) return;
    var sec = section();
    var hit = event.target.closest('[ref="addToCartButton"], .cly-size-guard');
    if (!sec || !hit || !sec.contains(hit)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showMissing();
  }, true);

  window.addEventListener('submit', function (event) {
    if (!isPending() || !(event.target instanceof Element)) return;
    var sec = section();
    if (!sec || !sec.contains(event.target) || !event.target.closest('product-form-component')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showMissing();
  }, true);

  document.addEventListener('change', function (event) {
    if (chosen) return;
    var fs = sizeFieldset();
    if (fs && fs.contains(event.target)) release();
  });

  document.addEventListener('variant:update', function () {
    if (chosen) return;
    clearSize();
    requestAnimationFrame(clearSize);
  });

  function init() {
    if (picker()) clearSize();
  }

  function start() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('variant-picker').then(start);
  } else {
    start();
  }
})();
